import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Http } from '@angular/http';

@Injectable()
export class EventService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  getAllEvents() {
    return this.authHttp.get('/api/event/all').map(res => res.json());
  }

  getAllEventsByType(id: number) {
    return this.authHttp.get('/api/eventbytype/' + id).map(res => res.json());
  }
  getAllVisibleEvents() {
    return this.http.get('/api/event/allVisible').map(res => res.json());
  }
  getEventById(id: number) {
    return this.authHttp.get('/api/event/' + id).map(res => res.json());
  }

  create(evenement: any) {
    return this.authHttp.post('/api/event', evenement).map(res => {
      return { 'status': res.status, 'value': res.json() };
    }
    );
  }

  update(evenement: any) {
    return this.authHttp.put('/api/event/' + evenement.id, evenement).map(res => res.status);
  }

  delete(evenement: any) {
    return this.authHttp.delete('/api/event/' + evenement.id).map(res => res.json());
  }

  changeVisible(id: number, isVisible: boolean) {
    return this.authHttp.get('/api/eventVisible/' + id + '/' + !isVisible).map(res => res.status);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/event.service.ts